import { Tooltip } from 'bootstrap';

// Initialize all tooltips
document.addEventListener('DOMContentLoaded', () => {
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]',
  );
  tooltipTriggerList.forEach((el) => new Tooltip(el));
});
